import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation('common');
  const navigate = useNavigate();

  const footerCategories = categories.slice(0, 5);
  const footerCategories2 = categories.slice(5, 10);

  return (
    <footer className="relative w-full bg-foreground-900 text-background-50 overflow-hidden">
      <div className="absolute bottom-0 left-0 right-0 select-none pointer-events-none">
        <span className="block font-heading text-[12vw] font-bold text-background-50/[0.03] leading-none whitespace-nowrap">
          CSSBuy.watch
        </span>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-16">
          <div className="lg:col-span-1">
            <a href="/" className="font-heading text-xl md:text-2xl font-bold text-background-50">
              CSSBuy<span className="text-primary-400">.</span>watch
            </a>
            <p className="mt-4 text-sm text-background-50/50 leading-relaxed max-w-xs">
              Seu guia confiável para encontrar os melhores produtos CSSBuy. Atualizado diariamente com curadoria de qualidade.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">
              {t('footer_navigation')}
            </h4>
            <div className="flex flex-col gap-2.5">
              {footerCategories.map((cat) => (
                <a
                  key={cat.id}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">
              &nbsp;
            </h4>
            <div className="flex flex-col gap-2.5">
              {footerCategories2.map((cat) => (
                <a
                  key={cat.id}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
              <button
                onClick={() => navigate('/cssbuy-sheet-guia-completo')}
                className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors whitespace-nowrap text-left cursor-pointer"
              >
                Blog SEO
              </button>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">
              {t('footer_social')}
            </h4>
            <div className="flex flex-col gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center gap-2.5 text-sm text-background-50/50 hover:text-background-50/80 transition-colors whitespace-nowrap"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-global-line"></i>
                </div>
                Site Principal
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center gap-2.5 text-sm text-background-50/50 hover:text-background-50/80 transition-colors whitespace-nowrap"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-shopping-bag-line"></i>
                </div>
                Comprar Agora
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center gap-2.5 text-sm text-background-50/50 hover:text-background-50/80 transition-colors whitespace-nowrap"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-file-list-line"></i>
                </div>
                CSSBuy Sheet
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; 2026 CSSBuy.watch. {t('footer_rights')}
          </p>
          <p className="text-xs text-background-50/30 max-w-md text-center sm:text-right">
            {t('footer_disclaimer')}
          </p>
        </div>
      </div>
    </footer>
  );
}